import { useEffect, useState } from "react";

const ADMIN_THEME_KEY = "adminTheme";
const ALLOWED_THEMES = ["light", "dark"];

const getStoredAdminTheme = () => {
  if (typeof window === "undefined" || !window.localStorage) {
    return "light";
  }

  try {
    const storedTheme = window.localStorage.getItem(ADMIN_THEME_KEY);

    return ALLOWED_THEMES.includes(storedTheme) ? storedTheme : "light";
  } catch {
    return "light";
  }
};

function useAdminTheme() {
  const [theme, setThemeState] = useState(getStoredAdminTheme);

  useEffect(() => {
    if (typeof window === "undefined" || !window.localStorage) {
      return;
    }

    try {
      window.localStorage.setItem(ADMIN_THEME_KEY, theme);
    } catch {
      // Ignore storage failures so admin pages still render safely.
    }
  }, [theme]);

  const setTheme = (nextTheme) => {
    setThemeState(ALLOWED_THEMES.includes(nextTheme) ? nextTheme : "light");
  };

  const toggleTheme = () => {
    setThemeState((currentTheme) =>
      currentTheme === "dark" ? "light" : "dark"
    );
  };

  return {
    theme,
    isDark: theme === "dark",
    toggleTheme,
    setTheme,
  };
}

export default useAdminTheme;
